// extracted by mini-css-extract-plugin
export default {"videoSection":"videoSection__NmI4O","sectionHr":"sectionHr__MmIwN"};